import { render, staticRenderFns } from "./charity.vue?vue&type=template&id=3bb56820"
import script from "./charity.vue?vue&type=script&lang=js"
export * from "./charity.vue?vue&type=script&lang=js"
import style0 from "./charity.vue?vue&type=style&index=0&id=3bb56820&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports